import React, { Component } from 'react';
import Slider from 'react-slick';
import CustomModal from '../common/CustomModal';
import { Modal } from 'react-bootstrap';
import { imageBasePath } from '../../constants/staticData';

function SampleNextArrow(props) {
    const {className, style, onClick} = props
    return (
      <div
        onClick={onClick}
      ><i className="mdi mdi-chevron-right"></i></div>
    );
  }

  function SamplePrevArrow(props) {
    const {className, style, onClick} = props
    return (
      <div
        onClick={onClick}
      ><i className="mdi mdi-chevron-left"></i></div>
    );
  }

class Onboarding extends Component {
    constructor() {
        super();
        this.state = {
            showModal: true,
        };
    }

    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />
        };
        return (
            <div>
                <button className="btn btn-default" onClick={() => { this.setState({ showModal: true });}}>modal open</button>
                <CustomModal  header={false} className="onboarding-modal" showModal={this.state.showModal}
                hideModal={() => {this.setState({ showModal: false }); this.props.closeAction();}}>
                    <Modal.Body>
                        <div className="onboarding">
                        <i className="mdi mdi-close" onClick={()=>{this.setState({showModal:false}); this.props.closeAction();}}></i>
                            <Slider {...settings}>
                                <div>
                                    <div className="img-holder">
                                        <img src={`${imageBasePath}/onboard2.png`} />
                                    </div>
                                    <div className="img-caption">
                                        <h4 className="caption-heading">Grow your business</h4>
                                        <p className="caption-text">Easy and affordable access to new customers anytime and build a wider clientele base.</p>
                                    </div>
                                </div>
                                <div>
                                    <div className="img-holder">
                                        <img src={`${imageBasePath}/onboard1.png`} />
                                    </div>
                                    <div className="img-caption">
                                        <h4 className="caption-heading">Improve your reputation</h4>
                                        <p className="caption-text">Get trusted online reviews and ratings.</p>
                                    </div>
                                </div>
                                <div>
                                    <div className="img-holder">
                                        <img src={`${imageBasePath}/onboard3.png`} />
                                    </div>
                                    <div className="img-caption">
                                        <h4 className="caption-heading">Manage your shop at your fingertips</h4>
                                        <p className="caption-text">We provide you with all the tech support to run your shop end-to-end online.</p>
                                    </div>
                                </div>

                            </Slider>

                        </div>
                    </Modal.Body>
                </CustomModal>
            </div>

        );
    }
}

export default Onboarding;



// WEBPACK FOOTER //
// ./src/components/Onboarding/Onboarding.jsx